import React from "react";
import { 
    AlertCircle,
    CircleCheck,
    Clock,
    Heart,
    Plus,
 } from "lucide-react";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import SupportTicket from "./components/SupportTicket";
import SupportTabs from "./components/SupportTabs";
import PopupButton from "components/button/PopupButton";
import { MODULE_SUPP_TICKETS } from "variables/constants";
import { connect } from "react-redux";

const HRSupport = () => {
    return (
        <div className="grid grid-cols-1">
            <div className="space-y-6 max-w-[1800px]">
                <SummaryHeader
                    title={"People & Culture"}
                    icon={Heart}
                    description={"Technical assistance and troubleshooting"}
                    color={"bg-pink"}
                    rightNav={
                        <PopupButton 
                            id="add_ticket" 
                            title="Submit People & Culture Ticket"
                            description="Share your HR questions, benefits inquiries, or workplace concerns"
                            label="New Ticket" 
                            btnClass="ticket btn-ticket pink" 
                            action="add"
                            moduleId={0}
                            icon={Plus}
                            useCustomClass={true}
                            modalWidth={500}
                        >
                            <SupportTicket recordId="0" mode="edit"/>
                        </PopupButton>
                    }
                >
                   <div className="summary-item-container">
                        <SummaryItem
                            title="Open Tickets"
                            icon={<AlertCircle />}
                            display="2"
                        />
                        <SummaryItem
                            title="In Progress"
                            icon={<Clock />}
                            display="2" 
                        />
                        <SummaryItem
                            title="Resolved"
                            icon={<CircleCheck />}
                            display="1" 
                        />
                   </div>
                </SummaryHeader>
                <SupportTabs />
            </div>
        </div>
    )
};

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(HRSupport);